import { render, staticRenderFns } from "./FeaturedCategory.vue?vue&type=template&id=78559262&scoped=true&"
import script from "./FeaturedCategory.vue?vue&type=script&lang=js&"
export * from "./FeaturedCategory.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCategory.vue?vue&type=style&index=0&id=78559262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78559262",
  null
  
)

export default component.exports